import { Outlet } from "react-router-dom"

const Root = () => {
  return <div className='root'>
    <Outlet></Outlet>
  </div>
}
export default Root